import React from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as SettingsActionCreators from '../../../actions/settings';

class MessagePreferences extends React.Component {
  /**
   * update Message Preferences
   * @return {undefined}
   */
  updateMessagePreferences = () => {
    this.props.dispatch(SettingsActionCreators.saveMessagePreferences(this.props.messagePreferences));
  }


  /**
   * Handle change
   * @param  {Object} e
   * @return {undefined}
   */
  handleChange = (e) => {
    const messagePreferences = this.props.messagePreferences;

    messagePreferences[e.target.name] = e.target.checked;

    this.props.dispatch(SettingsActionCreators.updateMessagePreferences(messagePreferences));
  }


  /**
   * Render
   * @return {JSX}
   */
  render() {
    const { messagePreferences, isSaving } = this.props;

    return (
      <div>
        <h2 className="heading heading--2">When should we message you directly?</h2>
        <form onSubmit={this.updateMessagePreferences}>
          <ul>
            <li className="checkbox">
              <label>
                <input id="MessageAboutNiceness" name="messageAboutNiceness" checked={!!messagePreferences.messageAboutNiceness} type="checkbox" onChange={this.handleChange} />
                {' '}
A player invites me to something
              </label>
            </li>
            <li className="checkbox">
              <label>
                <input id="MessageAboutNastiness" name="messageAboutNastiness" type="checkbox" checked={!!messagePreferences.messageAboutNastiness} onChange={this.handleChange} />
                {' '}
A player wants to engage me in combat
              </label>
            </li>
            <li className="checkbox">
              <label>
                <input id="MessageAboutAnnouncements" name="messageAboutAnnouncements" type="checkbox" checked={!!messagePreferences.messageAboutAnnouncements} onChange={this.handleChange} />
                {' '}
There is an announcement about the game
              </label>
            </li>
            <li className="checkbox">
              <label>
                <input id="MessageAboutStorylets" name="messageAboutStorylets" type="checkbox" checked={!!messagePreferences.messageAboutStorylets} onChange={this.handleChange} />
                {' '}
When a story develops
              </label>
            </li>
          </ul>
        </form>
        <p><button className="button button--primary" onClick={this.updateMessagePreferences}>{ isSaving ? 'Saving...' : 'Update' }</button></p>
      </div>
    );
  }
}


const mapStateToProps = state => (
  {
    messagePreferences: state.settings.messagePreferences,
    isSaving: state.settings.isSaving,
  }
);

export default withRouter(connect(mapStateToProps)(MessagePreferences));
